import React from 'react'
import style from './Welcome.module.css'

const Welcome = () => {
	return <section className={style.container}>Welcome For Case page</section>
}

export default Welcome
